import { jsx as _jsx } from "react/jsx-runtime";
// frontend/src/components/AgentsBoard/GithubReposEditor.tsx
// Autocomplete has no @weave-mui equivalent — matches SlackChannelPicker's existing precedent.
import { Autocomplete } from '@mui/material';
import { TextField } from '@weave-mui/material';
import { useKnownGitRepoUrls } from '../../api/hooks';
export const MAX_GITHUB_REPOS = 20;
/** Add/remove list of GitHub repo URLs an agent is scoped to (FR-004) — there's no
 * bot-joined-repos endpoint to back a picker the way SlackChannelPicker backs channels, so
 * suggestions come from `useKnownGitRepoUrls` (repos seen on already-loaded tasks) with
 * `freeSolo` still allowed for a repo that hasn't appeared on a task yet. Each add/remove is
 * its own committed onChange call, matching SlackChannelPicker's immediate-save semantics
 * rather than requiring a separate save step. */
export default function GithubReposEditor({ value, onChange }) {
    const atCap = value.length >= MAX_GITHUB_REPOS;
    const knownGitRepoUrls = useKnownGitRepoUrls();
    return (_jsx(Autocomplete, { multiple: true, freeSolo: true, size: "small", options: knownGitRepoUrls, value: value, onChange: (_e, newValue) => {
            const deduped = Array.from(new Set(newValue.map((v) => v.trim()).filter(Boolean)));
            onChange(deduped.slice(0, MAX_GITHUB_REPOS));
        }, renderInput: (params) => (_jsx(TextField, { ...params, label: "GitHub repos", helperText: atCap
                ? `Maximum ${MAX_GITHUB_REPOS} repos`
                : 'e.g. https://github.com/owner/repo — press Enter to add' })) }));
}
